export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.answering-rule-details', {
      url: 'answering-rule-details?ruleID',
      template: '<nets-answering-rule-details></nets-answering-rule-details>',
    });
};
